import React from 'react'
import { View } from 'react-native'

import Text from '@common/components/Text'
import useTheme from '@common/hooks/useTheme'
import { THEME_TYPES } from '@common/styles/themeConfig'
import { hexToRgba } from '@common/styles/utils/common'
import flexbox from '@common/styles/utils/flexbox'

type Props = {
  label: string
  value: React.ReactNode
  /** List row of the Review / order modals: 52px tall, hairline underneath. */
  divided?: boolean
  /** Last row of such a list: same height, no hairline. */
  isLast?: boolean
  emphasis?: boolean
  testID?: string
}

/** Label-left / value-right row used by the DCA form summary and the Review modal. */
const DcaRow = ({ label, value, divided, isLast, emphasis, testID }: Props) => {
  const { theme, themeType } = useTheme()
  // Same hairline as the form's dividers (DcaBalanceFooter).
  const dividerBorder =
    themeType === THEME_TYPES.LIGHT
      ? hexToRgba(theme.primaryBorder, 0.3)
      : (theme.primaryBorder as string)

  return (
    <View
      style={[
        flexbox.directionRow,
        flexbox.alignCenter,
        flexbox.justifySpaceBetween,
        {
          gap: 12,
          ...(divided
            ? {
                minHeight: 52,
                paddingVertical: 8,
                ...(isLast ? {} : { borderBottomWidth: 1, borderBottomColor: dividerBorder })
              }
            : { paddingVertical: 4 })
        }
      ]}
      testID={testID}
    >
      <Text fontSize={14} appearance="secondaryText" style={{ flexShrink: 1 }}>
        {label}
      </Text>
      {typeof value === 'string' ? (
        <Text
          fontSize={14}
          weight={emphasis ? 'semiBold' : 'medium'}
          style={{ textAlign: 'right', flexShrink: 1 }}
        >
          {value}
        </Text>
      ) : (
        value
      )}
    </View>
  )
}

export default React.memo(DcaRow)
